module.exports = __webpack_public_path__ + "img/77793c7.jpg";